import React from 'react';
import { Icon } from './Icon.js';
export const IconPinClock2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6.34315 4.42641C3.21895 7.66162 3.21895 12.9069 6.34315 16.1421L12 22L17.6569 16.1421C20.781 12.9069 20.781 7.66162 17.6569 4.42641C14.5327 1.1912 9.46734 1.1912 6.34315 4.42641Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M16 10L12 10L12 7", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPinClock2.js.map